export function MobileGenreStrip({categories,selected,onSelect}) {
  return <div className="mobile-genre-strip" role="group" aria-label="Browse genres">{['All',...Object.keys(categories).filter(name => name !== 'Latest Releases')].map(name => <button key={name} aria-pressed={selected === name} onClick={() => onSelect(name)}>{name === 'Science Fiction' ? 'Sci-Fi' : name}</button>)}</div>;
}

